import useUpdate from "@vnmfify/hooks/use-force-update"

export default useUpdate
